<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                <v-row justify="space-between">
                    <v-col cols="2">Plates</v-col>
                    <v-spacer />
                    <v-col cols="10" class="text-right">
                        <v-btn v-on:click="downloadPlateMapExcel()" color="info">
                            Download Plate Map
                            <v-icon end>$download</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card v-for="container of containers" :key="container.id">
                <v-card-title>Container {{ container.qrCode }} (ID {{ container.id }})</v-card-title>
                <v-card-subtitle>{{ container.containerTypeId }}</v-card-subtitle>
                <v-card-text>
                    <v-data-table :items="container.wells" :headers="wellHeaders">
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-card>
    </v-container>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { withLoadingScreen } from "@/lib/loading";
import { fetchContainers, downloadPlateMap } from "@/services/fermenterRuns/fermenterRunAPI";
import { Container } from "@/services/fermenterRuns/fermenterRunsService";
import { VDataTableHeader } from "@/vuetifyTypeFixes";
import { downloadFile } from "@/lib/downloadFileUtil";

const {
    experimentCode
} = defineProps<{
    experimentCode: string;
}>();

const containers = ref<Container[]>([]);

const wellHeaders: VDataTableHeader[] = [
    {
        title: "Position",
        value: "position",
        sortable: true,
        align: "start",
        width: "10%",
    },
    {
        title: "ID",
        value: "id",
        sortable: true,
        align: "start",
        width: "10%",
    },
    {
        title: "QR Code",
        value: "qrCode",
        sortable: true,
        align: "start",
        width: "10%",
    },
    {
        title: "Entity",
        value: "thingInstanceDataId",
        sortable: true,
        align: "start",
        width: "10%",
    }
]

withLoadingScreen(async () => {
    containers.value = await fetchContainers(experimentCode);
});

async function downloadPlateMapExcel() {
    const response = await downloadPlateMap(experimentCode);
    downloadFile(`${experimentCode}_Plate_Map.xlsx`, response);
}
</script>
